const preview = "io.prismic.preview";
export {
  preview
};
//# sourceMappingURL=cookie.js.map
